import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import { Search, Menu, X, ChevronRight, ChevronDown, ExternalLink, Home, BookOpen, Users, Zap, Coins, Settings, FileText, ArrowRight } from 'lucide-react';
import "./Whitepaper.css"

const GitBookStyleDocs = () => {
  const { section } = useParams()
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeSection, setActiveSection] = useState(section || 'disclaimer');
  const [searchQuery, setSearchQuery] = useState('');
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [expandedSections, setExpandedSections] = useState({
    'usdangl': false
  });

  

  // Documentation structure similar to MyANGL.ai
  const documentation = {
    'disclaimer': {
      title: 'Disclaimer',
      icon: FileText,
      type: 'html',
      content: `
        <div class="max-w-4xl mx-auto md:py-8 py-3">
          <header class="mb-8">
            <h1 class="text-4xl font-bold text-gray-900 mb-4">Disclaimer</h1>
          </header>

          <div class="space-y-6">
            <p class="text-gray-700 leading-relaxed">
              ANGL Inc. is registered in British Virgin Islands and structured as an International Business Company fully established, compliant, and capable of performing all the proposed activities stated within this white paper.
            </p>
            
            <p class="text-gray-700 leading-relaxed">
              The information contained in our white paper or FAQ is intended solely for general purposes and obtained from sources believed to be reliable. Any product or service mentioned should not be construed as an offer where engagement with such products and services is restricted or prohibited by law or regulation. Overall, there is no guarantee that ANGL Inc.  will deliver on its contents contained in this white paper due to various internal and external factors that may cause delays or failure.
            </p>
            
            <p class="text-gray-700 leading-relaxed">
              All information published by ANGL Inc.  is meant for informational purposes only and is not intended to serve as a recommendation to buy or sell and are not an offer or sale. All investments involve risk, and the past performance of any token does not guarantee future results or returns. Potential investors should seek professional advice and carefully review all documentation before making any financial decisions.
            </p>
            
            <div class="">
              <p class="text-red-500 text-lg">
                NOTHING IN THE WHITE PAPER OR FAQ SHOULD BE CONSTRUED AS ANY FORM OF ADVICE, INCLUDING, BUT NOT LIMITED TO FINANCIAL, LEGAL, OR TAX ADVICE.
              </p>
            </div>
          </div>
        </div>
      `
    },
    'usdangl': {
      title: '$ANGL',
      icon: Coins,
      type: 'html',
      content: `
      <div class="flex min-w-0 flex-1 flex-col">
  <div class="overflow-hidden -mx-4 sm:-mx-6 md:-mx-8 lg:-mr-8 lg:-ml-12">
    <img
      src="https://whitepaper.myangl.ai/~gitbook/image?url=https%3A%2F%2F252679884-files.gitbook.io%2F%7E%2Ffiles%2Fv0%2Fb%2Fgitbook-x-prod.appspot.com%2Fo%2Fspaces%252FwGIcBZt4CYGyMfBH1sT2%252Fuploads%252FU2unQivhuScdhRpL4ZKl%252Fwhitepaper%2520%288%29.png%3Falt%3Dmedia%26token%3Da93fb13e-216f-4b15-b9c4-34f66eb7add3&width=1248&dpr=2&quality=100&sign=f7f86c01&sv=2"
      alt="Page cover image"
      class="w-full object-cover object-center block"
      width="1990"
      height="480"
      sizes="(max-width: 768px) 768px, (max-width: 1024px) 992px, 1248px"
      style="aspect-ratio: 1990 / 480;"
    />
  </div>
 <div class="max-w-4xl mx-auto md:py-8 py-3">
      <header class="mb-8">
        <h1 class="text-4xl font-bold text-gray-900 mb-4">$ANGL</h1>
        <p class="text-lg text-gray-600">Your thoughts. Your AI. Your Economy.</p>
      </header>

      <div class="space-y-6">
        <h2 class="text-3xl font-semibold mb-4">Introduction</h2>
        
        <h4 class="text-xl font-semibold mb-3">Overview of ANGL Token</h4>
        
        <p class="text-gray-700 leading-relaxed mb-4">
         The ANGL Token ($ANGL) ecosystem seamlessly integrates artificial intelligence with blockchain technology to deliver a secure and innovative platform that provides the necessary tools to participate in the new AI economy. This ecosystem is designed to address critical challenges in the evolving digital economy by combining adaptive AI twins with a decentralized blockchain network.
        </p>
        
        <h4 class="text-xl font-semibold mb-3">Purpose and Value Proposition</h4>
        
        <p class="text-gray-700 leading-relaxed mb-4">
         ANGL Token puts power directly to its holders by providing solutions to key issues in the digital landscape, including data monopolies, unequal value distribution, and restricted access to advanced AI technologies controlled by large corporations. The platform enables users to:
       
<ul class="list-disc max-w-3xl mx-auto text-gray-700 space-y-2 text-start">
  <li class="text-base">
    Retain full ownership and control over their data.
  </li>
  <li class="text-base">
    Access personalized AI tools tailored to their unique needs.
  </li>
  <li class="text-base">
    Gain accessibility to the new and rapidly growing AI Economy.
  </li>
</ul>         </p>
        
        <h2 class="text-3xl font-semibold mb-4">Ecosystem</h2>
        
        <p class="text-gray-700 leading-relaxed">
          ANGL Token powers highly personalized, decentralized, and adaptive  AI models used as digital assistants for platform users. These AI twins leverage advanced machine learning. Your Twin will learn, adapt, and build to your unique needs, prompts, and determined goals. 
        </p>
      </div>
    </div>
</div>
    `,
      children: {
        'twin-ai': {
          title: 'Twin AI',
          type: 'html',
          content: `
            <main class="md:py-8 py-3">
              <header class="mx-auto mb-2 space-y-3">
                  <a href="/whitepaper/usdangl" class="underline-offset-2 text-s tracking-wide uppercase flex items-center gap-1.5 transition-all duration-100 no-underline hover:underline text-blue-600 hover:text-blue-800">
                    $ANGL
                  </a>
                <h1 class="text-4xl font-bold flex items-center gap-4">Twin AI</h1>
                <p class="text-2xl text-gray-500">Twin Key Features</p>
              </header>
              <div class="grid space-y-4">
                <p class="text-lg text-black">
                  Through our ecosystem partnerships you can utilize the ANGL token to grow your AI Twin which learns and customizes support with prompts, documents & other data stream inputs you select.
                </p>
                <p class="mx-auto text-lg text-black">
                  The more you facilitate with your Twin the more your Twin aligns with your specific objectives.
                </p>
                <h1 id="on-demand-ai-services-for-everyday-and-expert-use" class="text-3xl font-semibold relative group mx-auto w-full text-start leading-tight !mt-10">
                  <a href="#on-demand-ai-services-for-everyday-and-expert-use" aria-label="Direct link to heading" class="absolute -ml-6 mt-4 opacity-0 group-hover:opacity-100">
                    #
                  </a>
                  On-Demand AI Services for Everyday and Expert Use
                </h1>
                <p class="text-start font-bold">
                  Angel Twins provide real-time support for tasks like scheduling, marketing, and analytics. Designed for both daily productivity and advanced use cases, they adapt instantly to individual goals.
                </p>

                <h3 id="ai-powered-marketplace" class="text-2xl font-semibold relative group text-start leading-snug">
                  <a href="#ai-powered-marketplace" aria-label="Direct link to heading" class="absolute -ml-6 mt-2 opacity-0 group-hover:opacity-100">
                    #
                  </a>
                  AI-Powered Marketplace
                </h3>
                <p class="text-start">
                  Decentralized marketplace enables businesses to buy AI-powered sales bots and individuals to sell AI-driven tools, with developers.
                </p>

                <h3 id="tokenized-ai-generated-content" class="text-2xl font-semibold relative group  text-start leading-snug">
                  <a href="#tokenized-ai-generated-content" aria-label="Direct link to heading" class="absolute -ml-6 mt-2 opacity-0 group-hover:opacity-100">
                    #
                  </a>
                  Tokenized AI-Generated Content
                </h3>
                <p class="text-start">
                  ANGL tokens facilitate the monetization of AI-generated media, allowing users to license or own exclusive videos, art, music, or text created by customizable AI Twins on decentralized platforms.
                </p>

                <h3 id="data-monetization-and-ownership" class="text-2xl font-semibold relative group  text-start leading-snug">
                  <a href="#data-monetization-and-ownership" aria-label="Direct link to heading" class="absolute -ml-6 mt-2 opacity-0 group-hover:opacity-100">
                    #
                  </a>
                  Data Monetization & Ownership
                </h3>
                <p class="text-start">
                  Users earn ANGL by opting in to share anonymized data through their AI Twins, enabling researchers to access ethically sourced datasets while maintaining user control over personal data.
                </p>

                <h3 id="twin-as-a-service-taas" class="text-2xl font-semibold relative group text-start leading-snug">
                  <a href="#twin-as-a-service-taas" aria-label="Direct link to heading" class="absolute -ml-6 mt-2 opacity-0 group-hover:opacity-100">
                    #
                  </a>
                  Twin-as-a-Service (TaaS)
                </h3>
                <p class="text-start">
                  Businesses and individuals use ANGL tokens to deploy multilingual AI Twins for customer support and productivity, leveraging customizable automation tailored to specific operational needs.
                </p>

                <h3 id="digital-identity-and-verification" class="text-2xl font-semibold relative group  text-start leading-snug">
                  <a href="#digital-identity-and-verification" aria-label="Direct link to heading" class="absolute -ml-6 mt-2 opacity-0 group-hover:opacity-100">
                    #
                  </a>
                  Digital Identity & Verification
                </h3>
                <p class="text-start">
                  ANGL-powered AI Twins provide blockchain-secured digital IDs, enabling users to verify identities for contracts or logins through customizable, KYC-free biometric verification processes.
                </p>
              </div>
            </main>
          `
        },
        'data-ownership': {
          title: 'Data Ownership',
          type: 'html',
          content: `<main class="relative break-words md:py-8 py-3">
  <header class="mb-6 space-y-3">
    <nav>
          <a href="/whitepaper/usdangl"
             class="flex items-center gap-1.5 no-underline hover:underline transition-all duration-100 underline-offset-2 text-primary hover:text-primary-dark">
            $ANGL
          </a>
    </nav>
    <h1 class="text-4xl font-bold flex items-center gap-4">Data Ownership</h1>
    <p class="text-lg text-gray-600">Your Mind. Your Data. Your Rules.</p>
  </header>

  <div class="grid space-y-5 whitespace-pre-wrap">
    <p class=" text-left">With a user-centric design, AI Twin prioritizes the individual by automating digital priorities, data ownership, control & application. </p>
    <p class="text-left">AI tools to enhance your digital footprint </p>
    <p class="text-left">● Secure blockchain storage </p>
    <p class="text-left">● Productive data integration tools </p>
    <p class="text-left">● Data curation tools</p>
    <p class="text-left">● Myriad of data ingestion options</p>
  </div>
</main>
`
        },
        'ai-blockchain-integration': {
          title: 'AI Blockchain Integration',
          type: 'html',
          content: `<div class="flex grow flex-row-reverse justify-end">
  <!-- Main Content -->
  <main class="relative flex-1 md:py-8 py-3 break-words">
    <header class="mb-6 space-y-3">
      <nav>
            <a href="/whitepaper/usdangl" class="flex items-center gap-1.5 no-underline hover:underline transition-all duration-100 underline-offset-2 text-primary hover:text-primary-dark">
              $ANGL
            </a>
      </nav>
      <h1 class="text-4xl font-bold flex items-center gap-4">AI Blockchain Integration</h1>
      <p class="text-lg text-gray-600">AI + Blockchain = Innovation</p>
    </header>
    <div class="grid space-y-5">
      <h2 id="innovation-meets-legacy" class="text-3xl font-semibold relative group text-start">
        <div class="absolute -ml-6 mt-[1.05em] opacity-0 group-hover:opacity-100">
          <a href="#innovation-meets-legacy" aria-label="Direct link to heading" class="inline-flex h-full items-start">
            <svg class="w-4 h-4 text-transparent group-hover:text-gray-400" style="mask-image: url('https://ka-p.fontawesome.com/releases/v6.6.0/svgs/regular/hashtag.svg'); mask-repeat: no-repeat; mask-position: center;"></svg>
          </a>
        </div>
        <div class="z-10 mt-[1em]">Innovation Meets Legacy</div>
      </h2>
      <p class="text-start">Angel Twin introduces a transformative technology that seamlessly blends advanced AI with blockchain-enabled digital twin capabilities. </p>
      <p class="text-start">Leveraging, Angel AI, a precision-driven AI model powered by a sophisticated neural network, serves over 200,000 active users, and by incorporating the Twin Protocol and its secure Angel Wallet, this solution enables users to effortlessly ingest and manage information through AI-driven interfaces. </p>
      <p class="text-start">The Angel Wallet ensures data integrity and accessibility, leveraging blockchain’s decentralized framework to provide a trusted, tamper-proof repository. </p>
      <p class="text-start">This synergy empowers individuals and organizations to integrate actionable intelligence into their workflows, enhancing decision-making and innovation across diverse applications. </p>
    </div>
  </main>
</div>
`
        }
      }
    },
    'overview': {
      title: 'Overview',
      icon: FileText,
      type: 'html',
      content: `<div class="">

  <main class="relative min-w-0 flex-1 md:py-8 py-3 break-words">
    <!-- Page Header -->
    <header class=" mb-6 space-y-3">
      <h1 class="text-4xl font-bold flex items-center gap-4">Overview</h1>
      <p class="text-lg text-gray-600">Technical Architecture</p>
    </header>

    <!-- Content Section -->
    <div class="grid space-y-5">
      <p class="text-left">
        ANGL Token ecosystem architecture, focuses on the integration of AI twins adaptive, user-centric digital assistants.
      </p>

      <!-- Section with anchor -->
      <h2 id="ai-twin-integration" class="text-3xl font-semibold relative group text-left mt-8">
        <div class="absolute -ml-6 mt-4 opacity-0 group-hover:opacity-100 transition-opacity">
          <a href="#ai-twin-integration" aria-label="Direct link to heading" class="inline-flex items-center">
            <svg class="w-4 h-4 text-transparent group-hover:text-gray-400" style="mask-image: url('https://ka-p.fontawesome.com/releases/v6.6.0/svgs/regular/hashtag.svg'); mask-repeat: no-repeat; mask-position: center;"></svg>
          </a>
        </div>
        <div class="relative z-10">AI Twin Integration</div>
      </h2>

      <!-- Sub-section -->
      <h4 id="digital-assistants" class="text-xl font-semibold relative group text-left mt-4">
        <div class="absolute -ml-6 mt-2 opacity-0 group-hover:opacity-100 transition-opacity">
          <a href="#digital-assistants" aria-label="Direct link to heading" class="inline-flex items-center">
            <svg class="w-4 h-4 text-transparent group-hover:text-gray-400" style="mask-image: url('https://ka-p.fontawesome.com/releases/v6.6.0/svgs/regular/hashtag.svg'); mask-repeat: no-repeat; mask-position: center;"></svg>
          </a>
        </div>
        <div class="relative z-10">Digital Assistants</div>
      </h4>
      <p class="text-left">
        AI twins are the cornerstone of the ANGL Token ecosystem, functioning as personalized digital assistants that extend each user’s digital footprint.  
      </p>
      <p class="text-left">
       These assistants are powered by advanced machine learning models, allowing them to learn from user interactions, behaviors, and inputs. This results in highly customized and sophisticated automation tailored to individual needs.  
      </p>
      <p class="text-left">
        The primary way users engage with their AI twins is through the <strong class="font-bold">Angel Twin app</strong>, This app enables users to create, manage, and interact with their AI twins seamlessly. With a strong emphasis on <strong class="font-bold">user data empowerment, privacy, and accessibility</strong>, angltoken.io is designed to be intuitive and secure.
      </p>
 <p class="text-left text-lg">
        Here’s how $ANGL functions across specific technical areas: 
      </p>
      <!-- Bullet List -->
      <ul class="space-y-4 pl-4">
        <li class="flex items-start gap-2">
          <span class="text-lg font-bold">•</span>
          <p class="text-left text-lg">
            <strong>Twin ID Activation:</strong> A token balance in the AI Wallet is required to initiate and maintain active AI Twin sessions, ensuring only authorized users can access their twins.
          </p>
        </li>
        <li class="flex items-start gap-2">
          <span class="text-lg font-bold">•</span>
          <p class="text-left text-lg">
            <strong>Inference-Linked Billing:</strong> Each AI output—whether text, audio, or video—is computed against the user’s $ANGL balance, tying usage directly to token holdings.
          </p>
        </li>
        <li class="flex items-start gap-2">
          <span class="text-lg font-bold">•</span>
          <p class="text-left text-lg">
            <strong>Angel Wallet Memory Access:</strong> Deeper AI memory calls and historical data retrieval scale with $ANGL holdings, giving users with more tokens access to richer features.
          </p>
        </li>
        <li class="flex items-start gap-2">
          <span class="text-lg font-bold">•</span>
          <p class="text-left text-lg">
            <strong>Upgrade Mechanics:</strong> Real-time upgrades to avatars and compute capabilities (e.g., speed, realism, expressiveness, memory) are enabled through $ANGL expenditure.
          </p>
        </li>
        <li class="flex items-start gap-2">
          <span class="text-lg font-bold">•</span>
          <p class="text-left text-lg">
            <strong>Angel Points Bridging:</strong> Off-chain earned Angel Points can be converted to $ANGL via internal protocol logic, unlocking higher functionality within the ecosystem.
          </p>
        </li>
        <li class="flex items-start gap-2">
          <span class="text-lg font-bold">•</span>
          <p class="text-left text-lg">
            <strong>Referral Protocol:</strong> Users who refer others to activate their AI twins earn on-chain $ANGL rewards, tracked via Twin ID hashes, incentivizing growth. 
          </p>
        </li>
      </ul>
    </div>
  </main>
</div>
`
    },
    'technical-architecture': {
        title: 'Technical Architecture',
        icon: FileText,
        type: 'html',
        content: `
      <main class="relative min-w-0 flex-1 md:py-8 py-3">
  <header class="max-w-3xl mb-10 space-y-3">
    <h1 class="text-4xl font-bold flex items-center gap-4">Technical Architecture</h1>
  </header>

  <div class="grid space-y-5">
    <h2 class="text-2xl font-semibold max-w-3xl">Technical Components</h2>
    
    <p class="max-w-3xl text-start">Neural Networks & Natural Language Processing</p>
    
    <ul class="min-w-0 space-y-2 max-w-3xl">
      <li class="leading-normal flex items-start">
        <div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">
          <div>•</div>
        </div>
        <div class="flex min-w-0 flex-1 flex-col space-y-2">
          <p class="max-w-3xl text-start text-base">
            Neural Networks: The system employs multi-layer perceptrons (MLPs) and recurrent neural networks (RNNs) to process sequential user data, such as preferences and behavior patterns. These neural networks enable predictive capabilities, allowing AI twins to anticipate user needs and deliver proactive assistance.
          </p>
        </div>
      </li>
      <li class="leading-normal flex items-start text-base">
        <div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">
          <div>•</div>
        </div>
        <div class="flex min-w-0 flex-1 flex-col space-y-2">
          <p class="max-w-3xl text-start text-base">
            Natural Language Processing (NLP): Transformer-based models power the conversational abilities of AI twins. These models interpret and respond to user inputs naturally, facilitating fluid and intuitive communication.
          </p>
        </div>
      </li>
      <li class="leading-normal flex items-start">
        <div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">
          <div>•</div>
        </div>
        <div class="flex min-w-0 flex-1 flex-col space-y-2">
          <p class="max-w-3xl text-start text-base">
            Reinforcement Learning: Performance optimization is driven by reinforcement learning algorithms, which adapt and refine the AI twin's behavior over time based on user feedback. This ensures a highly tailored and evolving user experience.
          </p>
        </div>
      </li>
    </ul>

    <h2 class="text-2xl font-semibold max-w-3xl">User-Centric</h2>
    
    <p class="max-w-3xl text-start">Twin AI Application</p>
    
    <h4 class="text-xl font-semibold max-w-3xl">User-Centric Twin AI</h4>
    
    <p class="max-w-3xl text-start">
      The <strong class="font-bold">ANGL Token</strong> in <strong class="font-bold">angltoken.io</strong> focuses on <strong class="font-bold">assisting users</strong>, not replacing them. It builds a <strong class="font-bold">dynamic profile</strong> for personalized support and analytics, boosting digital legacy.
    </p>
    
    <p class="max-w-3xl text-start">
      <strong class="font-bold">$ANGL Token System</strong>
    </p>
    
    <p class="max-w-3xl text-start">
      <strong class="font-bold">$ANGL</strong> powers the app:
    </p>
    
    <ul class="min-w-0 space-y-2 max-w-3xl">
      <li class="leading-normal flex items-start">
        <div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">
          <div>•</div>
        </div>
        <div class="flex min-w-0 flex-1 flex-col space-y-2">
          <p class="max-w-3xl text-start text-base">
            <strong class="font-bold">Earn:</strong> Create Twins, refer users, or publish AI media.
          </p>
        </div>
      </li>
      <li class="leading-normal flex items-start">
        <div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">
          <div>•</div>
        </div>
        <div class="flex min-w-0 flex-1 flex-col space-y-2">
          <p class="max-w-3xl text-start text-base">
            <strong class="font-bold">Spend:</strong> Access compute, high-res sessions, or financial tools. It rewards engagement and unlocks features.
          </p>
        </div>
      </li>
    </ul>

    <h4 class="text-xl font-semibold max-w-3xl">User Control</h4>
    
    <p class="max-w-3xl text-start">
      Users <strong class="font-bold">own their data</strong> and <strong class="font-bold">digital legacy</strong> with privacy tools, while $ANGL enhances capabilities, ensuring accessibility and control.
    </p>

    <h2 class="text-3xl font-semibold max-w-3xl">Blockchain Storage</h2>
    
    <p class="max-w-3xl text-start">Ledger Transparency & Immutability</p>
    
    <p class="max-w-3xl text-start">
      <em class="italic">The following provides insights into the ANGL token blockchain infrastructure and the partners providing the service, powered by the ANGL token.</em>
    </p>

    <div class="overflow-x-auto max-w-3xl">
      <table class="w-full text-left border-collapse mt-4">
        <thead>
          <tr class="border bg-gray-100">
            <th class="border-b py-2 px-2 text-base">Component</th>
            <th class="border-b py-2 px-2 text-base">Storage Location</th>
            <th class="border-b py-2 px-2 text-base">Immutable</th>
            <th class="border-b py-2 pl-4 text-base">Details</th>
          </tr>
        </thead>
        <tbody>
          <tr class="border-t">
            <td class="py-2 px-4 border-r">$ANGL Token</td>
            <td class="py-2 px-4 border-r">Blockchain</td>
            <td class="py-2 px-4 border-r">Yes</td>
            <td class="py-2 pl-4">Ownership, transfers, balances</td>
          </tr>
          <tr class="border-t">
            <td class="py-2 px-4 border-r">Angel Twin ID</td>
            <td class="py-2 px-4 border-r">Blockchain</td>
            <td class="py-2 px-4 border-r">Yes</td>
            <td class="py-2 pl-4">Cryptographic identity</td>
          </tr>
          <tr class="border-t">
            <td class="py-2 px-4 border-r">Rewards (Angel Points)</td>
            <td class="py-2 px-4 border-r">Blockchain</td>
            <td class="py-2 px-4 border-r">Yes</td>
            <td class="py-2 pl-4">Transparent incentives</td>
          </tr>
          <tr class="border-t">
            <td class="py-2 px-4 border-r">Angel Wallet (Metadata)</td>
            <td class="py-2 px-4 border-r">Blockchain</td>
            <td class="py-2 px-4 border-r">Yes</td>
            <td class="py-2 pl-4">Hashes for auditability</td>
          </tr>
          <tr class="border-t">
            <td class="py-2 px-4 border-r">Angel Wallet (Content)</td>
            <td class="py-2 px-4 border-r">Cloud/Decentralized</td>
            <td class="py-2 px-4 border-r">No</td>
            <td class="py-2 pl-4">Scalable storage, linked by hashes</td>
          </tr>
        </tbody>
      </table>
    </div>

    <h4 class="text-xl font-semibold max-w-3xl">Storage in the ANGL Token Ecosystem</h4>
    
    <p class="max-w-3xl text-start">
      The ANGL Token ecosystem combines blockchain and cloud storage for security and efficiency:
    </p>
    
    <ul class="min-w-0 space-y-2 max-w-3xl">
      <li class="leading-normal flex items-start">
        <div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">
          <div>•</div>
        </div>
        <div class="flex min-w-0 flex-1 flex-col space-y-2">
          <p class="max-w-3xl text-start text-base">
            <strong class="font-bold">Blockchain:</strong> Stores immutable data like $ANGL tokens, Angel IDs, rewards, and financial info.
          </p>
        </div>
      </li>
      <li class="leading-normal flex items-start">
        <div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">
          <div>•</div>
        </div>
        <div class="flex min-w-0 flex-1 flex-col space-y-2">
          <p class="max-w-3xl text-start text-base">
            <strong class="font-bold">Cloud:</strong> Holds scalable data such as documents, prompts, and conversations.
          </p>
        </div>
      </li>
      <li class="leading-normal flex items-start">
        <div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">
          <div>•</div>
        </div>
        <div class="flex min-w-0 flex-1 flex-col space-y-2">
          <p class="max-w-3xl text-start text-base">
            <strong class="font-bold">Angel Wallet:</strong> Metadata on blockchain, content on cloud or decentralized storage, access via $ANGL.
          </p>
        </div>
      </li>
      <li class="leading-normal flex items-start">
        <div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">
          <div>•</div>
        </div>
        <div class="flex min-w-0 flex-1 flex-col space-y-2">
          <p class="max-w-3xl text-start text-base">
            <strong class="font-bold">ANGL Token Wallet:</strong> On blockchain, manages tokens and service access.
          </p>
        </div>
      </li>
    </ul>
    
    <p class="max-w-3xl text-start">
      Interconnection: The wallet links blockchain and cloud, with $ANGL enabling secure interactions. This ensures transparency, security, and user control.
    </p>

    <h2 class="text-3xl font-semibold max-w-3xl">Data Protection</h2>
    
    <p class="max-w-3xl text-start">Grade Protocols</p>
    
    <p class="max-w-3xl text-start">
      The Angel Wallet and Angel ID form the backbone of identity and data management in the ANGL Token ecosystem, blending security with user empowerment.
    </p>

    <h4 class="text-xl font-semibold max-w-3xl">Angel Wallet</h4>
    
    <p class="max-w-3xl text-start">
      The <strong class="font-bold">Angel Wallet</strong> is a decentralized container unique to each AI Twin, functioning as both a personal data store and a registry for neural network states.
    </p>

    <div class="overflow-x-auto max-w-3xl">
      <table class="w-full text-left border-collapse mt-4">
        <thead>
          <tr class="border bg-gray-100">
            <th class="border-b py-2 pr-4 text-base">Angel Wallet Component</th>
            <th class="border-b py-2 text-base">Technical Role</th>
          </tr>
        </thead>
        <tbody>
          <tr class="border-t">
            <td class="py-2 pr-4 border-r">Knowledge Layer</td>
            <td class="py-2 pl-4">Stores memory snapshots, embedding vectors, RAG results, and AI dialogue chains.</td>
          </tr>
          <tr class="border-t">
            <td class="py-2 pr-4 border-r">Access Layer</td>
            <td class="py-2 pl-4">Restricts access based on $ANGL transactions, user permissions, or holding thresholds.</td>
          </tr>
          <tr class="border-t">
            <td class="py-2 pr-4 border-r">State Sync</td>
            <td class="py-2 pl-4">Maintains a time-stamped ledger of AI-generated outputs linked to $ANGL triggers.</td>
          </tr>
          <tr class="border-t">
            <td class="py-2 pr-4 border-r">Zero-Knowledge Extensions (Planned)</td>
            <td class="py-2 pl-4">Will enable proof-of-training lineage for high-stakes or licensed AI content.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <h4 class="text-xl font-semibold max-w-3xl">Angel ID</h4>
    
    <p class="max-w-3xl text-start">
      The Angel ID is a non-transferable cryptographic identity derived from:
    </p>
    
    <ul class="min-w-0 space-y-2 max-w-3xl">
      <li class="leading-normal flex items-start">
        <div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">
          <div>•</div>
        </div>
        <div class="flex min-w-0 flex-1 flex-col space-y-2">
          <p class="max-w-3xl text-start text-base">
            An EVM-compatible wallet (requires signing for authentication).
          </p>
        </div>
      </li>
      <li class="leading-normal flex items-start">
        <div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">
          <div>•</div>
        </div>
        <div class="flex min-w-0 flex-1 flex-col space-y-2">
          <p class="max-w-3xl text-start text-base">
            A Angel Wallet metadata hash.
          </p>
        </div>
      </li>
      <li class="leading-normal flex items-start">
        <div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">
          <div>•</div>
        </div>
        <div class="flex min-w-0 flex-1 flex-col space-y-2">
          <p class="max-w-3xl text-start text-base">
            A neural profile fingerprint.
          </p>
        </div>
      </li>
    </ul>
    
    <p class="max-w-3xl text-start">
      How it works: Angel ID links you to your AI Twin across all decentralized applications (dApps) and interfaces in the ANGL Token network.
    </p>
  </div>
</main>
          `
      },
      'tokenomics': {
        title: 'Tokenomics',
        icon: FileText,
        type: 'html',
        content: `
       <main class="relative min-w-0 flex-1 max-w-screen-2xl md:py-8 py-3">
  <header class="max-w-3xl  mb-6 space-y-3">
    <h1 class="text-4xl font-bold flex items-center gap-4">Tokenomics</h1>
    <p class="text-xl text-gray-600">Purpose</p>
  </header>

  <section class="max-w-3xl space-y-6">
    <h2 class="text-3xl font-semibold">Utility</h2>
    <p class="text-lg">
      The <strong>$ANGL token</strong> is used for transactions within the ANGL Token ecosystem. Users access their Twin to use personalized AI services.
    </p>
    <ul class="list-disc list-inside space-y-2 text-lg">
      <li>Productivity tools</li>
      <li>Creative assistance</li>
      <li>Management functionality</li>
    </ul>

    <h3 class="text-2xl font-semibold mt-6">Tokenized Metering System</h3>
    <p class="text-lg">
     The ecosystem employs a metering system where $ANGL quantifies and manages resource consumption across various usage categories. This ensures fair and transparent allocation of computational resources and services. Below is a detailed breakdown: 
    </p>
    <div class="overflow-x-auto">
      <table class="w-full text-left border-collapse mt-4">
        <thead>
          <tr class="border bg-gray-100 rounded-lg px-4">
            <th class="border-b py-2 text-sm pl-2">Usage Category</th>
            <th class="border-b py-2 text-sm pl-4">Metered by ANGL</th>
          </tr>
        </thead>
        <tbody>
          <tr class="border-t">
            <td class="py-2 pr-4 font-bold border-r pl-2 text-sm">AI Output Volume</td>
            <td class="py-2 pl-4 text-sm">Charges based on a token-weighted quota tied to compute duration.</td>
          </tr>
          <tr class="border-t">
            <td class="py-2 pr-4 font-bold border-r pl-2 text-sm">Memory Depth</td>
            <td class="py-2 pl-4 text-sm">Deeper memory access and historical context retrieval require a higher $ANGL balance.</td>
          </tr>
          <tr class="border-t">
            <td class="py-2 pr-4 font-bold border-r pl-2 text-sm">Personal Finance Engine</td>
            <td class="py-2 pl-4 text-sm">Custom budget planning, real-time cash flow prediction, and behavioral analysis incur micro-fees in $ANGL.</td>
          </tr>
          <tr class="border-t">
            <td class="py-2 pr-4 font-bold border-r pl-2 text-sm">Avatar Layering</td>
            <td class="py-2 pl-4 text-sm">Higher-fidelity avatars (speed, emotional expression, multi-language) are gated via $ANGL tiers.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <h2 class="text-3xl font-semibold mt-10">Distribution</h2>
    <p>Token-Fairness</p>
    <p>$ANGL is designed for transparency and fairness along with scalable transactions.</p>
    <div class="flex justify-center mt-6">
      <img src="https://whitepaper.myangl.ai/~gitbook/image?url=https%3A%2F%2F252679884-files.gitbook.io%2F%7E%2Ffiles%2Fv0%2Fb%2Fgitbook-x-prod.appspot.com%2Fo%2Fspaces%252FwGIcBZt4CYGyMfBH1sT2%252Fuploads%252FGmjy2fUXwhMaUil1slzP%252FScreenshot%25202025-06-18%2520072707.png%3Falt%3Dmedia%26token%3D5858fc6c-d208-4bec-9397-3f58f33a41c3&width=768&dpr=2&quality=100&sign=1405dc9e&sv=2" alt="Tokenomics Chart" class="max-w-full h-auto">
    </div>

    <h2 class="text-3xl font-semibold !mt-12">Digital Economics</h2>
    <p>Circulating & Distributed supply</p>
    <p><strong>Token Type:</strong> ERC-20</p>
    <p><strong>Token Name:</strong> ANGL Token</p>
    <p><strong>Contract Address (CA):</strong> TBA</p>
    <p><strong>Supply:</strong> 1,000,000,000 fixed supply</p>
    <p><strong>Tax:</strong> 0/0</p>
    <p><strong>Initial Liquidity:</strong> 20%</p>
    <p><strong>Time Frame:</strong> 1y</p>
    <p><strong>Network:</strong> Ethereum (Main-Net)</p>
    <p><strong>Launchpad:</strong> Community-first fair launch; no pre-mining or VC allocations.</p>

    <h2 class="text-3xl font-semibold mt-10">Use Case</h2>
    <p>DeFi Integration</p>
    <p><strong>$ANGL</strong> supported by ANGL Token is a multifunctional tool that serves real world purposes.</p>
    <p><strong>$ANGL</strong> token is designed to power transactions for AI twin interactions, ensuring fair value distribution. </p>
    <p>Educating users on how to engage with AI Twins & informs investors about economic potential. </p>
    <p><strong>$ANGL</strong> helps document partnerships, explains token utility, and provides transparency through the white paper. </p>
    <p>The entire ANGL Token Ecosystem fosters education, trust, and personal data ownership. $ANGL is positioned as a leader in ethical AI and blockchain innovation. </p>
  </section>
</main>

          `
      },
      'challenges': {
        title: 'Challenges',
        icon: FileText,
        type: 'html',
        content: `
       <main class="relative flex-1 md:py-8 py-3">
  <!-- Header Section -->
  <header class="mb-6 space-y-3">
    <h1 class="text-4xl font-bold flex items-center gap-4">Challenges</h1>
    <p class="text-lg text-gray-600">Billions Left Behind, The Triple Crisis</p>
  </header>

  <!-- Content Section -->
  <div class="grid gap-3">
    <p>
      Around the world, billions of people face a lack of access to basic financial tools, education,
      and services, trapping them in cycles of economic instability. At the same time, many suffer from time
      poverty, overwhelmed by tasks and decisions without meaningful support.
    </p>
    <p>
      Compounding this is the growing issue of data exploitation; while AI technologies surge ahead,
      users have little control or ownership over their data or digital identity. This creates a deep inequity,
      expert financial guidance and time-saving tools remain privileges of the few, not the many.
    </p>
    <!-- Section: Productivity -->
    <h2 id="productivity" class="text-3xl font-semibold mt-4">Productivity</h2>

    <h4 id="usdangl-solution" class="text-xl font-semibold mt-2">$ANGL Solution</h4>
    <p>
      $ANGL aims to boost productivity with AI twins, $ANGL offers easy-to-use interfaces and tutorials. 
    </p>
    <p>
      AI twins also will assist during onboarding. Aimed to simplify the process, ensuring productivity and not overwhelming users.
    </p>

    <!-- Section: Labor Concerns -->
    <h2 id="labor-concerns" class="text-3xl font-semibold mt-4">Labor Concerns</h2>

    <h4 id="job-replacement" class="text-xl font-semibold mt-2">Job Replacement</h4>
    <p>
      $ANGL positions AI twins as assistants/companions that enhance, not replace.
    </p>
    <p>
      By giving users control, $ANGL aims to show AI twins help with routine tasks, freeing time for creative or strategic work, potentially improving job satisfaction. 
    </p>

    <!-- Section: Time Benefit -->
    <h2 id="time-benefit" class="text-3xl font-semibold mt-4">Time Benefit</h2>

    <h4 id="residual-value" class="text-xl font-semibold mt-2">Residual Value</h4>
    <p>
      AI twins can handle tasks like scheduling, letting users focus on higher-value activities and experiences.
    </p>
    <p>
      AI twins streamline repetitive tasks like scheduling, email management, and data organization, saving users hours of administrative work each week. This frees up time for strategic thinking, creative pursuits, or personal priorities. 
    </p>
    <p>
      <strong>Residual Value:</strong> By offloading routine tasks, AI twins enable users to invest their energy in high-impact activities, such as innovation, relationship-building, or skill development, creating long-term value that compounds over time. 
    </p>
  </div>  
  </div>
</main>

        `
      },
      'roadmap': {
        title: 'Roadmap',
        icon: FileText,
        type: 'html',
        content: `
       <main class="relative min-w-0 flex-1 md:py-8 py-3">
  <header class="max-w-3xl mb-6 space-y-3">
    <h1 class="text-4xl font-bold flex items-center gap-4">Roadmap</h1>
    <p class="text-lg text-gray-600">ANGL Token Utility Roadmap</p>
  </header>

  <div class="grid space-y-5">
    <p class="max-w-3xl text-start">Powering the Angel Twin Ecosystem (Q1 2025 – Q4 2026)</p>

    <!-- ==== Q1 2025 ==== -->
    <h4 class="text-xl font-semibold max-w-3xl">🔹 Q1 2025 — System Integration & Launch Foundation</h4>
    <p class="max-w-3xl text-start">Angel Wallet, Twin Protocol Integration, App Infrastructure</p>
    <ul class="min-w-0 space-y-2 max-w-3xl">
      <li class="leading-normal flex items-start">
        <div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">•</div>
        <div class="flex min-w-0 flex-1 flex-col space-y-2">
          <p class="max-w-3xl text-start">ANGL Utility:</p>
          <ul class="min-w-0 space-y-2 max-w-3xl">
            <li class="leading-normal flex items-start"><div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">◦</div><div class="flex min-w-0 flex-1 flex-col space-y-2"><p class="max-w-3xl text-start">Required for initial token-gated access to premium AI Twin services.</p></div></li>
            <li class="leading-normal flex items-start"><div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">◦</div><div class="flex min-w-0 flex-1 flex-col space-y-2"><p class="max-w-3xl text-start">Enables foundational login, registration, and wallet access tied to AI identities.</p></div></li>
            <li class="leading-normal flex items-start"><div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">◦</div><div class="flex min-w-0 flex-1 flex-col space-y-2"><p class="max-w-3xl text-start">Powers onboarding of Angel AI into the Twin Protocol ecosystem, linking Angel Wallets and smart contract billing.</p></div></li>
          </ul>
        </div>
      </li>
    </ul>

    <!-- ==== Q2 2025 ==== -->
    <h4 class="text-xl font-semibold max-w-3xl">🔹 Q2 2025 — Token Launch & Extended Angel Wallet</h4>
    <p class="max-w-3xl text-start">Smart Contract Deployment, TGE, Advanced Twin Services</p>
    <ul class="min-w-0 space-y-2 max-w-3xl">
      <li class="leading-normal flex items-start">
        <div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">•</div>
        <div class="flex min-w-0 flex-1 flex-col space-y-2">
          <p class="max-w-3xl text-start">ANGL Utility:</p>
          <ul class="min-w-0 space-y-2 max-w-3xl">
            <li class="leading-normal flex items-start"><div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">◦</div><div class="flex min-w-0 flex-1 flex-col space-y-2"><p class="max-w-3xl text-start">Required to unlock advanced AI features (e.g., scheduling, branding tools, broadcast capabilities).</p></div></li>
            <li class="leading-normal flex items-start"><div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">◦</div><div class="flex min-w-0 flex-1 flex-col space-y-2"><p class="max-w-3xl text-start">Extended Angel Wallet and memory management incur ANGL micro-payments.</p></div></li>
            <li class="leading-normal flex items-start"><div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">◦</div><div class="flex min-w-0 flex-1 flex-col space-y-2"><p class="max-w-3xl text-start">Used for creation of high-fidelity AI Twins with audio and video integration.</p></div></li>
            <li class="leading-normal flex items-start"><div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">◦</div><div class="flex min-w-0 flex-1 flex-col space-y-2"><p class="max-w-3xl text-start">Payment mechanism for real-time Twin interactions (chat, content requests, etc.).</p></div></li>
          </ul>
        </div>
      </li>
    </ul>

    <!-- ==== Q3 2025 ==== -->
    <h4 class="text-xl font-semibold max-w-3xl">🔹 Q3 2025 — Monetization & Marketplace Activation</h4>
    <p class="max-w-3xl text-start">Twin Points Conversion, Marketplace, Referral Rollout</p>
    <ul class="min-w-0 space-y-2 max-w-3xl">
      <li class="leading-normal flex items-start">
        <div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">•</div>
        <div class="flex min-w-0 flex-1 flex-col space-y-2">
          <p class="max-w-3xl text-start">ANGL Utility:</p>
          <ul class="min-w-0 space-y-2 max-w-3xl">
            <li class="leading-normal flex items-start"><div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">◦</div><div class="flex min-w-0 flex-1 flex-col space-y-2"><p class="max-w-3xl text-start">Enables conversion between earned Twin Points and tradable ANGL (inside Angel Wallet interface).</p></div></li>
            <li class="leading-normal flex items-start"><div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">◦</div><div class="flex min-w-0 flex-1 flex-col space-y-2"><p class="max-w-3xl text-start">All peer-to-peer marketplace transactions (hire, license, collaborate) are conducted in ANGL.</p></div></li>
            <li class="leading-normal flex items-start"><div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">◦</div><div class="flex min-w-0 flex-1 flex-col space-y-2"><p class="max-w-3xl text-start">Community and leaderboard contests distribute ANGL to top creators and users.</p></div></li>
            <li class="leading-normal flex items-start"><div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">◦</div><div class="flex min-w-0 flex-1 flex-col space-y-2"><p class="max-w-3xl text-start">Ingestion tools that convert user uploads into trainable AI memory are paid for in ANGL.</p></div></li>
            <li class="leading-normal flex items-start"><div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">◦</div><div class="flex min-w-0 flex-1 flex-col space-y-2"><p class="max-w-3xl text-start">Two-tier referral commissions (2% direct / 1% indirect) are paid out in ANGL.</p></div></li>
          </ul>
        </div>
      </li>
    </ul>

  <!-- ==== Q4 2025 ==== -->
<h4 class="text-xl font-semibold max-w-3xl">🔹 Q4 2025 — Customization, Angel Wallet Scaling, and Web Access</h4>
<p class="max-w-3xl text-start">AI Twin Branding, Angel Wallet, Twin Interface Expansion</p>
<ul class="min-w-0 space-y-2 max-w-3xl">
  <li class="leading-normal flex items-start">
    <div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">•</div>
    <div class="flex min-w-0 flex-1 flex-col space-y-2">
      <p class="max-w-3xl text-start">ANGL Utility:</p>
      <ul class="min-w-0 space-y-2 max-w-3xl">
        <li class="leading-normal flex items-start">
          <div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">◦</div>
          <div class="flex min-w-0 flex-1 flex-col space-y-2">
            <p class="max-w-3xl text-start">Payment method for Twin customization (voice models, tone, visual avatars).</p>
          </div>
        </li>
        <li class="leading-normal flex items-start">
          <div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">◦</div>
          <div class="flex min-w-0 flex-1 flex-col space-y-2">
            <p class="max-w-3xl text-start">Angel Wallet scaling (not staking) requires ANGL to expand memory, metadata tags, and data type support.</p>
          </div>
        </li>
        <li class="leading-normal flex items-start">
          <div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">◦</div>
          <div class="flex min-w-0 flex-1 flex-col space-y-2">
            <p class="max-w-3xl text-start">Used for unlocking higher-frequency usage of AI Twins in business and personal workflows.</p>
          </div>
        </li>
        <li class="leading-normal flex items-start">
          <div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">◦</div>
          <div class="flex min-w-0 flex-1 flex-col space-y-2">
            <p class="max-w-3xl text-start">Required for activating professional web-based Twin dashboards and export tools.</p>
          </div>
        </li>
      </ul>
    </div>
  </li>
</ul>

<!-- ==== Q1 2026 ==== -->
<h4 class="text-xl font-semibold max-w-3xl">🔹 Q1 2026 — Real-World Expansion & Smart Devices</h4>
<p class="max-w-3xl text-start">IRL Interactions, Brand Events, IoT Integration</p>
<ul class="min-w-0 space-y-2 max-w-3xl">
  <li class="leading-normal flex items-start">
    <div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">•</div>
    <div class="flex min-w-0 flex-1 flex-col space-y-2">
      <p class="max-w-3xl text-start">ANGL Utility:</p>
      <ul class="min-w-0 space-y-2 max-w-3xl">
        <li class="leading-normal flex items-start">
          <div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">◦</div>
          <div class="flex min-w-0 flex-1 flex-col space-y-2">
            <p class="max-w-3xl text-start">Used for session-based Twin deployments at live events, stores, or conferences.</p>
          </div>
        </li>
        <li class="leading-normal flex items-start">
          <div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">◦</div>
          <div class="flex min-w-0 flex-1 flex-col space-y-2">
            <p class="max-w-3xl text-start">Smart device and kiosk interactions with Twins require ANGL payments per user session.</p>
          </div>
        </li>
        <li class="leading-normal flex items-start">
          <div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">◦</div>
          <div class="flex min-w-0 flex-1 flex-col space-y-2">
            <p class="max-w-3xl text-start">Monthly enterprise usage licenses paid in ANGL for companies using AI Twins for customer engagement.</p>
          </div>
        </li>
      </ul>
    </div>
  </li>
</ul>

<!-- ==== Q2 2026 ==== -->
<h4 class="text-xl font-semibold max-w-3xl">🔹 Q2 2026 — Developer Tools & Cross-Platform Access</h4>
<p class="max-w-3xl text-start">SDK/API Releases, AI Integrations, Business Features</p>
<ul class="min-w-0 space-y-2 max-w-3xl">
  <li class="leading-normal flex items-start">
    <div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">•</div>
    <div class="flex min-w-0 flex-1 flex-col space-y-2">
      <p class="max-w-3xl text-start">ANGL Utility:</p>
      <ul class="min-w-0 space-y-2 max-w-3xl">
        <li class="leading-normal flex items-start">
          <div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">◦</div>
          <div class="flex min-w-0 flex-1 flex-col space-y-2">
            <p class="max-w-3xl text-start">API and SDK access for developers requires ANGL for authentication and usage.</p>
          </div>
        </li>
        <li class="leading-normal flex items-start">
          <div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">◦</div>
          <div class="flex min-w-0 flex-1 flex-col space-y-2">
            <p class="max-w-3xl text-start">Businesses pay in ANGL to access analytics dashboards, training data reports, and team-wide Twin deployment.</p>
          </div>
        </li>
        <li class="leading-normal flex items-start">
          <div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">◦</div>
          <div class="flex min-w-0 flex-1 flex-col space-y-2">
            <p class="max-w-3xl text-start">Compute billing and AI model usage metered in ANGL across partner apps and services.</p>
          </div>
        </li>
      </ul>
    </div>
  </li>
</ul>

<!-- ==== Q3 2026 ==== -->
<h4 class="text-xl font-semibold max-w-3xl">🔹 Q3 2026 — Digital Asset Licensing</h4>
<p class="max-w-3xl text-start">Twin Publishing, Licensing & Monetization of Digital Twins</p>
<ul class="min-w-0 space-y-2 max-w-3xl">
  <li class="leading-normal flex items-start">
    <div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">•</div>
    <div class="flex min-w-0 flex-1 flex-col space-y-2">
      <p class="max-w-3xl text-start">ANGL Utility:</p>
      <ul class="min-w-0 space-y-2 max-w-3xl">
        <li class="leading-normal flex items-start">
          <div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">◦</div>
          <div class="flex min-w-0 flex-1 flex-col space-y-2">
            <p class="max-w-3xl text-start">Twin owners publish Digital Assets (AI-driven personas) on the marketplace using ANGL.</p>
          </div>
        </li>
        <li class="leading-normal flex items-start">
          <div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">◦</div>
          <div class="flex min-w-0 flex-1 flex-col space-y-2">
            <p class="max-w-3xl text-start">Licensing rights, reuse permissions, and access tiers are monetized through ANGL transactions.</p>
          </div>
        </li>
        <li class="leading-normal flex items-start">
          <div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">◦</div>
          <div class="flex min-w-0 flex-1 flex-col space-y-2">
            <p class="max-w-3xl text-start">Royalties and smart licensing tracked and distributed using ANGL.</p>
          </div>
        </li>
      </ul>
    </div>
  </li>
</ul>

<!-- ==== Q4 2026 ==== -->
<h4 class="text-xl font-semibold max-w-3xl">🔹 Q4 2026 — Utility Scale-Up & Automation Tools</h4>
<p class="max-w-3xl text-start">Web Twin Automations, Pro Features, Bulk Usage</p>
<ul class="min-w-0 space-y-2 max-w-3xl">
  <li class="leading-normal flex items-start">
    <div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">•</div>
    <div class="flex min-w-0 flex-1 flex-col space-y-2">
      <p class="max-w-3xl text-start">ANGL Utility:</p>
      <ul class="min-w-0 space-y-2 max-w-3xl">
        <li class="leading-normal flex items-start">
          <div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">◦</div>
          <div class="flex min-w-0 flex-1 flex-col space-y-2">
            <p class="max-w-3xl text-start">Power users can automate Twins for scheduled messages, media posts, and follow-up replies—billed in ANGL.</p>
          </div>
        </li>
        <li class="leading-normal flex items-start">
          <div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">◦</div>
          <div class="flex min-w-0 flex-1 flex-col space-y-2">
            <p class="max-w-3xl text-start">Bulk Angel Wallet uploads and advanced metadata indexing incur ANGL usage fees.</p>
          </div>
        </li>
        <li class="leading-normal flex items-start">
          <div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">◦</div>
          <div class="flex min-w-0 flex-1 flex-col space-y-2">
            <p class="max-w-3xl text-start">High-traffic brands pay ANGL to whitelist domains and scale Twin usage across larger audiences.</p>
          </div>
        </li>
      </ul>
    </div>
  </li>
</ul>
  </div>
</main>

        `
      },
      'community': {
        title: 'Community',
        icon: FileText,
        type: 'html',
        content: `<main class="relative min-w-0 flex-1 md:py-8 py-3">
  <header class="max-w-3xl mb-6 space-y-3">
    <h1 class="text-4xl font-bold flex items-center gap-4">Community</h1>
    <p class="text-lg text-gray-600">Interactive Community Hubs</p>
  </header>

  <div class="grid space-y-5">
    <p class="max-w-3xl text-start">
      <strong class="font-bold"></strong>The $ANGL ecosystem fosters vibrant community interaction through virtual hubs on platforms such as Twitter/X, Discord, and Telegram. These hubs host engaging events, including:
    </p>

    <p class="max-w-3xl text-start">
      ● Live AMAs: Interactive Q&amp;A sessions with the $ANGL team, delivering project updates and insights.
    </p>

    <p class="max-w-3xl text-start">
      ● Developer Workshops: Tutorials designed to guide developers in building within the $ANGL ecosystem.
    </p>

    <p class="max-w-3xl text-start">
      Connect with our global community to share success stories, ideas, and updates via:
    </p>

    <p class="max-w-3xl text-start break-words">
      ● Linktree: <a href="https://linktr.ee/myangelai" target="_blank" class="text-blue-600 underline break-words">linktr.ee/myangelai</a>
    </p>

    <p class="max-w-3xl text-start break-words">
      ● Twitter/X: <a href="https://x.com/ANGL_Token" target="_blank" class="text-blue-600 underline break-words">x.com/ANGL_Token</a>
    </p>

    <p class="max-w-3xl text-start break-words">
      ● Telegram: <a href="https://t.me/angeltwinsai" target="_blank" class="text-blue-600 underline break-words">https://t.me/angeltwinsai</a>
    </p>

    <p class="max-w-3xl text-start break-words">
      ● Website: <a href="https://angltoken.io" target="_blank" class="text-blue-600 underline break-words">angltoken.io</a> | <a href="https://angelai.com" target="_blank" class="text-blue-600 underline break-words">angelai.com</a>
    </p>

    <p class="max-w-3xl text-start break-all">
      ● App Store: <a href="https://apps.apple.com/us/app/angelai/id1667401139" target="_blank" class="text-blue-600 underline break-words">apps.apple.com/us/app/angelai/id1667401139</a>
    </p>

    <p class="max-w-3xl text-start">
      <strong class="font-bold">Community Features</strong>
    </p>

    <p class="max-w-3xl text-start">
      ● Community Chats: Collaborative spaces for users to exchange ideas and seek support.
    </p>

    <p class="max-w-3xl text-start">
      ● Dedicated Support Channels: For technical assistance, inquiries, and general discussions.
    </p>

    <p class="max-w-3xl text-start">
      ● Moderated Environment: Ensuring respectful and productive interactions.
    </p>

    <p class="max-w-3xl text-start">
      ● Multilingual Support: Serving our diverse global user base.
    </p>
  </div>
</main>

        `
      },
      'conclusion': {
        title: 'Conclusion',
        icon: FileText,
        type: 'html',
        content: `<main class="relative min-w-0 flex-1 md:py-8 py-3">
  <header class="max-w-3xl mb-6 space-y-3">
    <h1 class="text-4xl font-bold flex items-center gap-4">Conclusion</h1>
  </header>

  <div class="grid space-y-5">
    <h2 class="text-3xl font-semibold max-w-3xl">
      Own Your Thoughts. Power Your AI. Build Your Economy.
    </h2>

    <p class="max-w-3xl text-start">
      The ANGL Token represents a new kind of digital infrastructure—one where intelligence is personal, value is transparent, and users are in control.
    </p>

    <p class="max-w-3xl text-start">
      In a world increasingly shaped by opaque algorithms and centralized platforms, $ANGL offers a different path:
    </p>

    <ul class="min-w-0 space-y-2 max-w-3xl">
      <li class="leading-normal flex items-start">
        <div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">
          <div>•</div>
        </div>
        <div class="flex min-w-0 flex-1 flex-col space-y-2">
          <p class="max-w-3xl text-start text-base">
            A token that fuels personalized AI agents you own and train.
          </p>
        </div>
      </li>
      <li class="leading-normal flex items-start">
        <div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">
          <div>•</div>
        </div>
        <div class="flex min-w-0 flex-1 flex-col space-y-2">
          <p class="max-w-3xl text-start text-base">
            A system that rewards your participation, not your data exploitation.
          </p>
        </div>
      </li>
      <li class="leading-normal flex items-start">
        <div class="text-base leading-normal mr-1 flex min-h-[1lh] min-w-6 items-center justify-center text-gray-600">
          <div>•</div>
        </div>
        <div class="flex min-w-0 flex-1 flex-col space-y-2">
          <p class="max-w-3xl text-start text-base">
            A platform where everyday people, not just corporations, gain leverage in the AI economy.
          </p>
        </div>
      </li>
    </ul>

    <p class="max-w-3xl text-start">
      From powering your AI Twin to securing your Angel Wallet, from real-time productivity to long-term digital asset licensing—every action in the Angel Twin ecosystem is connected through $ANGL. This isn't just a token; it's the energy source of a fairer, smarter, and more human future.
    </p>

    <p class="max-w-3xl text-start">
      As we continue expanding the Angel Twin platform—across industries, communities, and devices—we invite you to join this transformation. Whether you're a creator, a developer, a small business, or someone ready to reclaim their data and digital destiny, ANGL is your key.
    </p>

    <p class="max-w-3xl text-start">
      This is more than a protocol.
    </p>

    <p class="max-w-3xl text-start">
      It's your AI. Your data. Your future.
    </p>

    <p class="max-w-3xl text-start">
      <strong class="font-bold">Welcome to the era of Personal Intelligence. Powered by $ANGL.</strong>
    </p>
  </div>
</main>

        `
      },
  };

  // Navigation structure
  const navigationItems = [
    { id: 'disclaimer', title: 'Disclaimer', icon: FileText },
    {
      id: 'usdangl',
      title: '$ANGL',
      icon: Coins,
      children: [
        { id: 'twin-ai', title: 'Twin AI' },
        { id: 'data-ownership', title: 'Data Ownership' },
        { id: 'ai-blockchain-integration', title: 'AI Blockchain Integration' }
      ]
    },
    { id: 'overview', title: 'Overview', icon: BookOpen },
    { id: 'technical-architecture', title: 'Technical Architecture', icon: BookOpen },
    { id: 'tokenomics', title: 'Tokenomics', icon: BookOpen },
    { id: 'challenges', title: 'Challenges', icon: BookOpen },
    { id: 'roadmap', title: 'Roadmap', icon: BookOpen },
    { id: 'community', title: 'Community', icon: BookOpen },
    { id: 'conclusion', title: 'Conclusion', icon: BookOpen }
  ];

  // Create flat navigation array for prev/next functionality
  const flatNavigation = [];
  navigationItems.forEach(item => {
    flatNavigation.push({
      id: item.id,
      title: item.title,
      parentTitle: null
    });
    if (item.children) {
      item.children.forEach(child => {
        flatNavigation.push({
          id: child.id,
          title: child.title,
          parentTitle: item.title
        });
      });
    }
  });

  const stripHtmlTags = (html) => {
    return html.replace(/<[^>]*>/g, '');
  };

  // Create searchable content index
  const createSearchIndex = () => {
    const searchableContent = [];
    
    // Index top-level pages
    Object.entries(documentation).forEach(([key, value]) => {
      if (value.content) {
        searchableContent.push({
          id: key,
          title: value.title,
          content: stripHtmlTags(value.content),
          type: 'page',
          parentTitle: null
        });
      }
      
      // Index child pages
      if (value.children) {
        Object.entries(value.children).forEach(([childKey, childValue]) => {
          searchableContent.push({
            id: childKey,
            title: childValue.title,
            content: stripHtmlTags(childValue.content), 
            type: 'page',
            parentTitle: value.title
          });
        });
      }
    });
    
    return searchableContent;
  };

  const searchIndex = createSearchIndex();

  // Search functionality
  const performSearch = (query) => {
    if (!query.trim()) {
      setSearchResults([]);
      return;
    }

    const normalizedQuery = query.toLowerCase();
    const results = [];

    searchIndex.forEach(item => {
      const titleMatch = item.title.toLowerCase().includes(normalizedQuery);
      const contentMatch = item.content.toLowerCase().includes(normalizedQuery);
      
      if (titleMatch || contentMatch) {
        // Extract relevant content snippet
        const sentences = item.content.split('\n').filter(line => 
          line.trim() && !line.startsWith('#') && !line.startsWith('*')
        );
        
        let snippet = '';
        let relevanceScore = 0;
        
        if (titleMatch) {
          relevanceScore += 10;
        }
        
        // Find the most relevant sentence
        for (const sentence of sentences) {
          if (sentence.toLowerCase().includes(normalizedQuery)) {
            const startIndex = Math.max(0, sentence.toLowerCase().indexOf(normalizedQuery) - 50);
            snippet = sentence.substring(startIndex, startIndex + 150) + '...';
            relevanceScore += 5;
            break;
          }
        }
        
        // If no direct match, take first meaningful sentence
        if (!snippet && sentences.length > 0) {
          snippet = sentences[0].substring(0, 150) + '...';
          relevanceScore += 1;
        }
        
        results.push({
          ...item,
          snippet: snippet.replace(/[#*]/g, '').trim(),
          relevanceScore
        });
      }
    });

    // Sort by relevance score (highest first)
    results.sort((a, b) => b.relevanceScore - a.relevanceScore);
    setSearchResults(results.slice(0, 10)); // Limit to top 10 results
  };

  // Handle search input
  const handleSearch = (query) => {
    setSearchQuery(query);
    performSearch(query);
  };

  // Navigate to search result
  const navigateToSearchResult = (resultId) => {
    navigateToPage(resultId);
    setSearchOpen(false);
    setSearchQuery('');
    setSearchResults([]);
  };

  // Highlight search terms in text
  const highlightSearchTerm = (text, searchTerm) => {
    if (!searchTerm.trim()) return text;
    
    const regex = new RegExp(`(${searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
    const parts = text.split(regex);
    
    return parts.map((part, index) => 
      regex.test(part) ? 
        React.createElement('mark', { key: index, className: "bg-yellow-200 px-1 rounded" }, part) : 
        part
    );
  };

  // Get current content
  const getCurrentContent = () => {
    if (activeSection === 'technical-architecture') {
      return documentation['technical-architecture'];
    }
    const parts = activeSection.split('-');
    if (parts.length === 1) {
      return documentation[activeSection];
    } else {
      const [parent, child] = parts[0] === 'overview' || parts[0] === 'who' 
        ? ['introduction', activeSection] 
        : parts[0] === 'angel' || parts[0] === 'roadmap'
        ? ['angl-ecosystem', activeSection]
        : ['usdangl', activeSection];
      
      return documentation[parent]?.children?.[child] || documentation[parent];
    }
  };

  // Get navigation info for current page
  const getNavigationInfo = () => {
    const currentIndex = flatNavigation.findIndex(item => item.id === activeSection);
    const prevPage = currentIndex > 0 ? flatNavigation[currentIndex - 1] : null;
    const nextPage = currentIndex < flatNavigation.length - 1 ? flatNavigation[currentIndex + 1] : null;
    
    return { prevPage, nextPage };
  };

  // Navigate to page
  const navigateToPage = (pageId) => {
    setActiveSection(pageId);
    window.scrollTo({ top: 0, behavior: 'smooth' });
    window.history.pushState({}, '', `/whitepaper/${pageId}`);
    // Auto-expand parent section if needed
    // const targetItem = navigationItems.find(item => 
    //   item.id === pageId || (item.children && item.children.some(child => child.id === pageId))
    // );
    
    // if (targetItem && targetItem.children) {
    //   setExpandedSections(prev => ({
    //     ...prev,
    //     [targetItem.id]: true
    //   }));
    // } else if (targetItem) {
    //   // Find parent if it's a child item
    //   const parentItem = navigationItems.find(item => 
    //     item.children && item.children.some(child => child.id === pageId)
    //   );
    //   if (parentItem) {
    //     setExpandedSections(prev => ({
    //       ...prev,
    //       [parentItem.id]: true
    //     }));
    //   }
    // }
  };

  // Keyboard shortcuts
  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
        e.preventDefault();
        setSearchOpen(true);
      }
      if (e.key === 'Escape') {
        setSearchOpen(false);
        setSearchQuery('');
        setSearchResults([]);
        setSidebarOpen(false);
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  // Handle $ANGL link clicks
useEffect(() => {
  const handleLinkClick = (e) => {
    if (e.target.tagName === 'A' && e.target.textContent.includes('$ANGL')) {
      e.preventDefault();
      navigateToPage('usdangl');
    }
  };
  
  document.addEventListener('click', handleLinkClick);
  return () => document.removeEventListener('click', handleLinkClick);
}, []);

  // Toggle section expansion
  const toggleSection = (sectionId) => {
    setExpandedSections(prev => ({
      ...prev,
      [sectionId]: !prev[sectionId]
    }));
  };

  // Render HTML content safely
  const renderHtmlContent = (htmlContent) => {
    return (
      <div 
        className="prose prose-lg max-w-none"
        dangerouslySetInnerHTML={{ __html: htmlContent }}
      />
    );
  };

  // Render markdown-like content
  const renderMarkdownContent = (content) => {
    if (!content) return null;
  
    return (
      <div className="prose prose-lg max-w-none">
        {content.split('\n').map((line, index) => {
          line = line.trim();
          if (!line) return <br key={index} />;
  
          if (line.startsWith('# ')) {
            return <h1 key={index} className="text-3xl font-bold mb-6 text-gray-900">{line.substring(2)}</h1>;
          } else if (line.startsWith('## ')) {
            return <h2 key={index} className="text-2xl font-semibold mb-4 mt-8 text-gray-800">{line.substring(3)}</h2>;
          } else if (line.startsWith('### ')) {
            return <h3 key={index} className="text-xl font-semibold mb-3 mt-6 text-gray-800">{line.substring(4)}</h3>;
          } else if (line.startsWith('- ')) {
            return <li key={index} className="ml-6 mb-2 text-gray-700 list-disc">{line.substring(2)}</li>;
          } else if (line.includes('✔') || line.includes('')) {
            return <div key={index} className="flex items-start mb-3 text-gray-700">{line}</div>;
          } else if (line.includes('**')) {
            const parts = line.split('**');
            return (
              <p key={index} className="mb-4 leading-relaxed text-gray-700">
                {parts.map((part, i) =>
                  i % 2 === 1 ? <strong key={i} className="font-semibold text-gray-900">{part}</strong> : part
                )}
              </p>
            );
          } else if (line.startsWith('*Last updated')) {
            return <p key={index} className="text-sm text-gray-500 italic mt-6">{line}</p>;
          } else {
            return <p key={index} className="mb-4 leading-relaxed text-gray-700">{line}</p>;
          }
        })}
      </div>
    );
  };

  // Render content based on type
  const renderContent = (contentObj) => {
    if (!contentObj || !contentObj.content) return null;
    
    if (contentObj.type === 'html') {
      return renderHtmlContent(contentObj.content);
    } else {
      return renderMarkdownContent(contentObj.content);
    }
  };

  const currentContent = getCurrentContent();

  return (
    <div className="flex h-screen bg-white">
      {/* Sidebar */}
      <div className={`${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} lg:translate-x-0 fixed lg:fixed z-30 w-80 md:w-96 h-full bg-gray-50 border-r border-gray-200 transition-transform duration-300 ease-in-out`}>
        <div className="flex flex-col h-full">
          {/* Header */}
          <div className="p-4 border-b border-gray-200">
            <div className="flex items-center justify-between">
              {/* <h1 className="text-xl font-bold text-gray-900">MyANGL.ai</h1> */}
              <button
                onClick={() => setSidebarOpen(false)}
                className="lg:hidden p-1 rounded-md hover:bg-gray-200"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
            
            {/* Search */}
            <div className="mt-2 relative">
              <div 
                className="flex items-center w-full px-3 py-2 text-sm bg-white border border-gray-300 rounded-lg cursor-pointer hover:border-gray-400"
                onClick={() => setSearchOpen(true)}
              >
                <Search className="w-4 h-4 mr-2 text-gray-400" />
                <span className="text-gray-500">Search...</span>
                <span className="ml-auto text-xs text-gray-400">⌘K</span>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <nav className="flex-1 p-4 overflow-y-auto">
            <ul className="space-y-1 pb-20">
              {navigationItems.map((item) => (
                <li key={item.id}>
                  <div className="flex items-center">
                    <button
                      onClick={() => {
                        navigateToPage(item.id);
                        setSidebarOpen(false);
                        if (item.children) {
                          setExpandedSections(prev => ({
                            ...prev,
                            [item.id]: !prev[item.id]
                          }));
                        }
                      }}
                      
                      className={`flex items-center w-full px-3 py-2 text-sm rounded-lg transition-colors ${
                        activeSection === item.id 
                          ? 'bg-blue-100 text-blue-700' 
                          : 'text-gray-700 hover:bg-gray-100'
                      }`}
                    >
                      {/* <item.icon className="w-4 h-4 mr-3" /> */}
                      <span className="flex-1 text-left">{item.title}</span>
                      {item.children && (
                        expandedSections[item.id] 
                          ? <ChevronDown className="w-4 h-4" />
                          : <ChevronRight className="w-4 h-4" />
                      )}
                    </button>
                  </div>
                  
                  {item.children && expandedSections[item.id] && (
                    <ul className="ml-7 mt-1 space-y-1">
                      {item.children.map((child) => (
                        <li key={child.id}>
                          <button
                            onClick={() => {
                              navigateToPage(child.id);
                              setSidebarOpen(false);
                            }}
                            className={`block w-full px-3 py-2 text-sm text-left rounded-lg transition-colors ${
                              activeSection === child.id 
                                ? 'bg-blue-100 text-blue-700' 
                                : 'text-gray-600 hover:bg-gray-100'
                            }`}
                          >
                            {child.title}
                          </button>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>

      {/* Main content */}
      <div className="flex-1 flex flex-col min-w-0 lg:ml-96 scrollbar-hide">
        {/* Top bar */}
        <header className="lg:hidden flex items-center justify-between p-4 border-b border-gray-200 bg-white">
          <button
            onClick={() => setSidebarOpen(true)}
            className="p-1 rounded-md hover:bg-gray-100"
          >
            <Menu className="w-5 h-5" />
          </button>
          {/* <h1 className="text-lg font-semibold">MyANGL.ai</h1> */}
          <div className="w-6" />
        </header>

        {/* Content area */}
        <main className="flex-1">
          <div className="max-w-4xl mx-auto px-6 md:py-8 py-3">
            {currentContent && renderContent(currentContent)}
            
            {/* Navigation footer */}
            <div className="flex items-center justify-between mt-4">
              {(() => {
                const { prevPage, nextPage } = getNavigationInfo();
                return (
                  <>
                   {prevPage && (
                    <div className="flex-1 border border-gray-200 pt-3 pb-3">
                     
                        <button
                          onClick={() => navigateToPage(prevPage.id)}
                          className="flex items-center text-sm text-gray-600 hover:text-blue-600 transition-colors group pl-4"
                        >
                          <ArrowRight className="w-4 h-4 mr-1 rotate-180 group-hover:-translate-x-1 transition-transform" />
                          <div className="text-left">
                            <div className="text-xs text-gray-500">Previous</div>
                            <div className="font-medium">
                              {prevPage.parentTitle && prevPage.parentTitle !== prevPage.title 
                                ? `${prevPage.parentTitle}: ${prevPage.title}` 
                                : prevPage.title}
                            </div>
                          </div>
                        </button>
                    </div>
                    )}
                    {nextPage && (
                    <div className="flex-1 flex justify-end border border-gray-200 ml-2 pt-3 pb-3">     
                        <button
                          onClick={() => navigateToPage(nextPage.id)}
                          className="flex items-center text-sm text-gray-600 hover:text-blue-600 transition-colors group pr-4"
                        >
                          <div className="text-right">
                            <div className="text-xs text-gray-500">Next</div>
                            <div className="font-medium">
                              {nextPage.parentTitle && nextPage.parentTitle !== nextPage.title 
                                ? `${nextPage.parentTitle}: ${nextPage.title}` 
                                : nextPage.title}
                            </div>
                          </div>
                          <ArrowRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" />
                        </button> 
                    </div>
                     )}
                  </>
                );
              })()}
            </div>
          </div>
        </main>
      </div>

      {/* Search overlay */}
      {searchOpen && (
        <div className="fixed inset-0 z-50 flex items-start justify-center pt-20 bg-black bg-opacity-50">
          <div className="w-full max-w-2xl mx-4 bg-white rounded-lg shadow-2xl">
            <div className="flex items-center px-4 py-3 border-b border-gray-200">
              <Search className="w-5 h-5 mr-3 text-gray-400" />
              <input
                type="text"
                placeholder="Search documentation..."
                className="flex-1 outline-none text-lg"
                autoFocus
                value={searchQuery}
                onChange={(e) => handleSearch(e.target.value)}
              />
              <button
                onClick={() => {
                  setSearchOpen(false);
                  setSearchQuery('');
                  setSearchResults([]);
                }}
                className="ml-3 p-1 rounded-md hover:bg-gray-100"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
            <div className="p-4 max-h-96">
              {searchQuery.trim() === '' ? (
                <div className="text-sm text-gray-500">
                  Start typing to search the documentation...
                </div>
              ) : searchResults.length === 0 ? (
                <div className="text-sm text-gray-500">
                  No results found for "{searchQuery}"
                </div>
              ) : (
                <div className="space-y-3">
                  <div className="text-sm text-gray-500 mb-3">
                    Found {searchResults.length} result{searchResults.length !== 1 ? 's' : ''}
                  </div>
                  {searchResults.map((result, index) => (
                    <button
                      key={result.id}
                      onClick={() => navigateToSearchResult(result.id)}
                      className="w-full text-left p-3 rounded-lg hover:bg-gray-50 border border-gray-100 transition-colors"
                    >
                      <div className="flex items-start justify-between">
                        <div className="flex-1 min-w-0">
                          <div className="flex items-center space-x-2">
                            {result.parentTitle && (
                              <span className="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded">
                                {result.parentTitle}
                              </span>
                            )}
                            <h3 className="font-medium text-gray-900 truncate">
                              {highlightSearchTerm(result.title, searchQuery)}
                            </h3>
                          </div>
                          {result.snippet && (
                            <p className="text-sm text-gray-600 mt-1 line-clamp-2">
                              {highlightSearchTerm(result.snippet, searchQuery)}
                            </p>
                          )}
                        </div>
                        <ArrowRight className="w-4 h-4 text-gray-400 ml-2 flex-shrink-0" />
                      </div>
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Mobile sidebar overlay */}
      {sidebarOpen && (
        <div 
          className="lg:hidden fixed inset-0 z-20 bg-black bg-opacity-50"
          onClick={() => setSidebarOpen(false)}
        />
      )}
    </div>
  );
};

export default GitBookStyleDocs;